import { BillGsmDetailsInterfaceState, initialBillGsmDetailsState } from '../state/bill-gsm-details.state';
import { EBillGsmDetailsActions, GetBillGsmDetailsActions } from '../actions/bill-gsm-details.actions';

export function billGsmDetailsReducer(state: BillGsmDetailsInterfaceState = initialBillGsmDetailsState, action: GetBillGsmDetailsActions): BillGsmDetailsInterfaceState {
  switch (action.type) {
    case EBillGsmDetailsActions.GetBillGsmDetailsSuccess: {
      return { ...state, list: action.payload };
    }

    default:
      return state;
  }
};
